import React, { Component } from "react";
import { RequestorInfoCard } from "./RequestorInfoCard";
import { PickupAddressCard } from "./PickupAddress";
import { FreightTypeChoice} from './FreightTypeChoice';
import { Constants } from '../../Constants'

export class BookingQuote extends Component{
    constructor(props) {
        super(props);    
        this.state = {
            transportType: null,
            freightType: null,

            transportTypeSelected: false,
            freightTypeSelected: false,

			formSubmitting: false,
            submitButtonText: "Get quote",
        };  
        var inlandAndOceanFreight = "inlandAndOceanFreight";
        var oceanFreightOnly = "oceanFreightOnly";
        // This binding is necessary to make `this` work in the callback
        this.changeTransportType = this.changeTransportType.bind(this);
        this.changeFreightType = this.changeFreightType.bind(this);

        this.setFormSubmitting = this.setFormSubmitting.bind(this);
		
        this.updateOriginPort = this.updateOriginPort.bind(this);
        this.updateDestinationPort = this.updateDestinationPort.bind(this);
    }

    changeTransportType = (e) => {this.setState({transportType: e, transportTypeSelected: true}); };

    changeFreightType = (e) => {this.setState({freightType: e, freightTypeSelected: true}); };
    
	updateOriginPort = (port) => {
        this.setState({selectedOriginPort: port});
    }
    updateDestinationPort = (port) => {
        this.setState({selectedDestinationPort: port});
    }

	setFormSubmitting = (value) => {
        if(value){
            this.setState({submitButtonText: "Please wait...",
                formSubmitting: value});
        }else{
            this.setState({formSubmitting: value});
        }
    };

    transportTypeChoice() {
        return(
            <div className="col-12">
                <div className="row">                    
                    <strong>{Constants.SelectYourServiceQuote}</strong>
                    <div className="form-check my-1">
                        <input type="radio" className="form-check-input"
                            id="Inland-Ocean-Transport" name="transportType" value="inlandAndOceanFreight"
                            onClick={() => this.changeTransportType("inlandAndOceanFreight")}/>

                        <label className="form-check-label" {...{"for":"Inland-Ocean-Transport"}}>
                            {Constants.InlandAndOceanFreightQuoteDescription}
                            <i className="ml-1 fa fa-truck-pickup"></i>
                            <i className="fa fa-plus"></i>
                            <i className="fa fa-ship"></i>
                        </label>
                    </div>

                    <div className="form-check mb-1">
                        <input type="radio" className="form-check-input"
                            id="Ocean-Transport" name="transportType" value="oceanFreightOnly"
                            onClick={() => this.changeTransportType("oceanFreightOnly")}/>
                            
                        <label className="form-check-label" for="Ocean-Transport">
                            {Constants.OceanFreightOnlyQuoteDescription}
                            <i className="ml-1 fa fa-ship"></i>
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    render(){
        // All JSX elements initially set to null.
        var requestorInfo, pickupAddress, freightTypeChoice, submitButton, quantityAndAddlnfoQuery;        
        
        // The following logic assigns the appropriate elements with props to them
        if(this.state.transportTypeSelected){
            requestorInfo = <RequestorInfoCard />
            if(this.state.transportType === "inlandAndOceanFreight"){
                pickupAddress  = <PickupAddressCard />
            }
            freightTypeChoice = <FreightTypeChoice onChoiceChange={this.changeFreightType} onOriginPortChange={this.updateOriginPort} onDestinationPortChange={this.updateDestinationPort}/> 
        }
        if(this.state.freightTypeSelected){
            quantityAndAddlnfoQuery = 
                <div className="col-sm-12 col-md-4 mt-2">
                    <label className="mb-1"><strong>How many {this.state.freightType}s are you looking to ship?</strong></label>
                    <input required min="1" type="number" name="freightQuantity" id="typeNumber" defaultValue={1} className="form-control" />
                    <label class="mt-2 form-label" for="Additional-Information">(Optional) Any additional information about the {this.state.freightType}s?</label>
                    <textarea class="form-control" name="additionalInformation" id="Additional-Information" rows="3"></textarea>
                </div>
        }

        if(this.state.freightTypeSelected && this.state.transportTypeSelected){
            submitButton = 
            <div className="col-12 mb-3">
                <hr/>
                <button type="submit" disabled={this.state.formSubmitting} className="btn btn-primary btn-lg btn-block">
                    {this.state.submitButtonText}
                </button>
            </div>
        }

        return(
            <div className="container-lg">
                <form method="post" action="/BookingQuote" onSubmit={() => this.setFormSubmitting(true)}>
                    <div className="row">
						<em className="my-3">Need help? You can review our video guide to filling out this form by clicking <a href="https://youtu.be/SW50mBh3kp0" target="_blank" rel="noreferrer noopener">here</a></em>
                        {this.transportTypeChoice()}
                        {requestorInfo}
                        {pickupAddress}
                        {freightTypeChoice}
                        {quantityAndAddlnfoQuery}
                        {submitButton}
                    </div>
                </form>           
            </div>
        );
    }
}